import CredixApp from "@components/CredixApp/CredixApp";
import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.scss";

ReactDOM.render(
	<React.StrictMode>
		<CredixApp />
	</React.StrictMode>,
	document.getElementById("root")
);
